/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { VerifyAccountLink } from '../../../redux/features/auth/authActions';
import { MESSAGES } from '../../../utlis/messages';


export function AccountVerify() {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const [verificationMessage, setVerificationMessage] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') || '';
    const otp = searchParams.get('otp') || null;


    useEffect(() => {
        if (email && otp) {
            dispatch(VerifyAccountLink({ email, otp }))
                .then((response: any) => {                    
                    if (response?.payload?.responseCode === 200) {
                        setVerificationMessage(MESSAGES.VERIFICATION_SUCCESS);
                        setIsSuccess(true);
                    } else {
                        setVerificationMessage(MESSAGES.INVALID_VERIFICATION_LINK);
                        setIsSuccess(false);
                    }
                })
                .catch(() => {
                    setVerificationMessage(MESSAGES.INVALID_VERIFICATION_LINK);
                    setIsSuccess(false);
                })
                .finally(() => setLoading(false));
        } else {
            setVerificationMessage(MESSAGES.INVALID_VERIFICATION_LINK);
            setIsSuccess(false);
            setLoading(false);
        }
    }, [email, otp]);



    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <h1 className="text-2xl font-bold mb-4">{MESSAGES.ACCOUNT_VERIFICATION}</h1>
            {loading ? (
                <p className="text-gray-600">{MESSAGES.ACCOUNT_VERIFIED}...</p>
            ) : (
                <p style={{ color: isSuccess ? "green" : "red" }}>
                    {verificationMessage}
                </p>
            )}

            <Link to='/auth/login'>
                <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-primary'
                >
                    {MESSAGES.GO_TO_LOGIN}
                </button>
            </Link>
        </div>
    );
}
